export async function searchGhostPosts(searchText) {
  if (typeof searchText === "undefined" || searchText === null) {
    return [];
  }

  const normalizedQuery = searchText
    .toString()
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

  if (!normalizedQuery) {
    return [];
  }

  const GHOST_API_URL = process.env.NEXT_PUBLIC_GHOST_API_URL;
  const GHOST_API_KEY = process.env.NEXT_PUBLIC_GHOST_API_KEY;

  if (!GHOST_API_URL || !GHOST_API_KEY) {
    console.error("Ghost search missing NEXT_PUBLIC_GHOST_API_URL or NEXT_PUBLIC_GHOST_API_KEY");
    return [];
  }

  const url = new URL(`${GHOST_API_URL.replace(/\/+$/, "")}/ghost/api/content/posts/`);
  url.searchParams.set("key", GHOST_API_KEY);
  url.searchParams.set("include", "tags");
  url.searchParams.set("limit", "200");
  url.searchParams.set("order", "published_at desc");
  url.searchParams.set("fields", "id,title,slug,url,canonical_url");

  try {
    const response = await fetch(url.toString());
    if (!response.ok) {
      console.error("Ghost search API error", response.status, response.statusText);
      return [];
    }

    const data = await response.json();
    const rawPosts = Array.isArray(data?.posts) ? data.posts : [];
    const allowedTags = new Set(["college", "counselling", "blogs"]);

    const results = rawPosts
      .map((post) => {
        const tags = Array.isArray(post.tags)
          ? post.tags.map((tag) => ({
              id: tag.id,
              name: tag.name,
              slug: tag.slug,
            }))
          : [];

        return {
          id: post.id,
          title: post.title,
          slug: post.slug,
          url: post.url,
          canonical_url: post.canonical_url,
          tags,
        };
      })
      .filter((post) => {
        const title = (post.title || "")
          .toString()
          .trim()
          .replace(/\s+/g, " ")
          .toLowerCase();

        if (!title.includes(normalizedQuery)) {
          return false;
        }

        return post.tags.some((tag) => {
          const name = (tag.name || "").toString().toLowerCase();
          const slug = (tag.slug || "").toString().toLowerCase();
          return allowedTags.has(name) || allowedTags.has(slug);
        });
      })
      .slice(0, 10);

    return results;
  } catch (error) {
    console.error("Ghost search request failed", error);
    return [];
  }
}
